import { WeeklyReport, WeeklyReportEmailRequest, WeeklyReportEmailResponse } from '../types/report';
import { fetcher } from '../utils/fetcher';

const API_URL = '/api/v1/reports';

/** `weekStart` is any date in the wanted week; the API snaps it to that week's Monday. */
export const getWeeklyReport = async (weekStart?: string): Promise<WeeklyReport> => {
  return await fetcher(`${API_URL}/weekly${weekStart ? `?week_start=${weekStart}` : ''}`);
};

export const emailWeeklyReport = async (
  data: WeeklyReportEmailRequest
): Promise<WeeklyReportEmailResponse> => {
  return await fetcher(`${API_URL}/weekly/email`, {
    method: 'POST',
    body: JSON.stringify(data),
  });
};
